(() => {
  const SELECTORS = {
    banner: ".vt-landing-a__banner",
    playButton: ".js-play-video",
    thumbnail: ".vt-landing-a__banner--content-video-thumbnail",
    video: ".vt-landing-a__banner--content-video video",
    youtube: ".vt-landing-a__banner--content-video .js-youtube-embed",
    content: ".vt-landing-a__banner--content"
  };
  const hideOverlay = ({ playButton, thumbnail, content }) => {
    if (playButton) {
      playButton.classList.add("is-hidden");
      playButton.setAttribute("aria-hidden", "true");
      playButton.blur();
    }
    if (thumbnail) {
      thumbnail.classList.add("is-hidden");
    }
  };
  const playVideo = (video) => {
    var _a;
    if (!video) {
      return;
    }
    const playPromise = (_a = video.play) == null ? void 0 : _a.call(video);
    if (playPromise && typeof playPromise.then === "function") {
      playPromise.catch(() => {
      });
    }
  };
  const playYouTube = (iframe) => {
    if (!iframe) {
      return;
    }
    try {
      const message = JSON.stringify({
        event: "command",
        func: "playVideo"
      });
      iframe.contentWindow.postMessage(message, "*");
    } catch (error) {
      console.error("postMessage failed:", error);
    }
    const currentSrc = iframe.src;
    if (currentSrc && !currentSrc.includes("autoplay=1")) {
      const newSrc = currentSrc.includes("?") ? `${currentSrc}&autoplay=1` : `${currentSrc}?autoplay=1`;
      iframe.src = newSrc;
    }
  };
  const handleActivation = ({ playButton, thumbnail, video, iframe, content }) => {
    if (!playButton || playButton.classList.contains("is-hidden")) {
      return;
    }
    hideOverlay({ playButton, thumbnail, content });
    if (iframe) {
      playYouTube(iframe);
    } else if (video) {
      playVideo(video);
    }
  };
  const bindPlayButton = (playButton) => {
    const banner = playButton.closest(SELECTORS.banner);
    if (!banner) {
      return;
    }
    const thumbnail = banner.querySelector(SELECTORS.thumbnail);
    const video = banner.querySelector(SELECTORS.video);
    const iframe = banner.querySelector(SELECTORS.youtube);
    const content = banner.querySelector(SELECTORS.content);
    const activate = () => handleActivation({ playButton, thumbnail, video, iframe, content });
    playButton.addEventListener("click", activate);
    playButton.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
        event.preventDefault();
        activate();
      }
    });
  };
  const init = () => {
    const playButtons = document.querySelectorAll(SELECTORS.playButton);
    if (!playButtons.length) {
      return;
    }
    playButtons.forEach(bindPlayButton);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
